<template>
  <div>
    <h3 class="h-title">提交文件-拟存储文件</h3> 
    <el-form class="e-form f-b" ref="cForm" :model="cForm" label-width="200"  label-position="left" :rules="setpFormRules5">     
      <el-form-item label="合同类型">
        {{contractFormat(cForm.contractType)}}
      </el-form-item>
      <el-form-item class="w-70" label="拟存储文件" prop="planSaveFileList">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'planSaveFileList')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'planSaveFileList')" 
            :on-error="handleError"
            :file-list="cForm.planSaveFileList || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
        <div class="el-form-item__error" v-show="isFile">
          请上传
        </div>
      </el-form-item> 
      <span class="tag">注：如出现从合同时，须将主从合同同时打包上传，≤80Mb</span>
    </el-form>
    <div class="d-tag">
      <p>为了更好地维护您的合法权益，建议您根据下列提示上传链证存储文件:、合同基础文件</p>
      <p>(一) 资产转让类合同</p>
      <p>《资产转让合同》《资产权属证明》 《资产转让价款划付凭证》 《资产交割凭证》《确权文件》;</p>
      <p>(二) 货物买卖合同</p>
      <p>《货物买卖合同》 《货款支付凭证》 《货物清单》《提单》《发货单》 《收货单》《确权文件》;</p>
      <p>(三) 借款合同</p>
      <p>《借款合同》《借款划付凭证》《借款归还凭证》《确权文件》;</p>
      <p>(四) 租赁合同</p>
      <p>《租赁合同》《运输合同》 《租金支付凭证》《租赁物交付凭证》《租赁物归还凭证》 《确权文件》;</p>
      <p>(五) 《服务合同》 《服务费用支付凭证》 《服务完成验收单》。</p>
      <p>二、合同增信文件</p>
      <p>《增信方基础资料》(三证合一、公司简介、公司章程、法定代表人身份证)，《担保函》《抵押物评估报告》《证券登记机构办理出质登记)《质押物评估报告》《质押合同》《管理部门办理出质登记》。</p>
      <p>三、资产流转合同</p>
      <p>《资产流转主合同》《资产流转后各方的确权文件》《资产流转的付款凭证》《资产流转的交付凭证》</p>
      <p>四、其他跟本合同相关的文件</p>
    </div>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">提 交</el-button>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
export default {
  name: "step5",
  props: ["active"],
  data() {
    return {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token")
      },
      action: '',
      butLoading: false,
      cForm: {},
      setpFormRules5: {
        planSaveFileList: [
            { type: 'array', required: true, message: '请上传', trigger: 'change' }
        ]
      },
      isFile: false,
      contractOptions: [],
    }
  },
  watch: {
      active(newVal) {
        if(newVal == 5) {
          window.scrollTo(0,0);
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          this.$api.api.getDicts("xf_contract_type").then(response => {
            this.contractOptions = response.data;
          });
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm = JSON.parse(sessionStorage.setpForm);
          this.cForm.planSaveFileList = JSON.parse(this.cForm.planSaveFile || '[]');
        } 
      }
    },
  methods: {  
    selectDictLabel(datas, value) {
        var actions = [];
        Object.keys(datas).some((key) => {
            if (datas[key].dictValue == ('' + value)) {
                actions.push(datas[key].dictLabel);
                return true;
            }
        })
        return actions.join('');
    },
    contractFormat (val) {
      return this.selectDictLabel(this.contractOptions, val);
    },
    prev() {
      this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFileList||[]);
      sessionStorage.setpForm = JSON.stringify(this.cForm);
      this.$emit('prev')
    },
    cSubmitForm(status){
      if(status == '0'){
        this.butLoading = true;
        this.cForm.status = status
        this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFileList||[]);

        this.$api.consumer.addAndUpd(JSON.stringify(this.cForm)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.go(-1);
          }else {
            this.$message.error(response.msg);
          }      
        });
      }else {
        if (this.cForm.planSaveFileList.length > 0) {
          this.butLoading = true;
          this.cForm.status = status
          this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFileList||[]);

          this.$api.consumer.addAndUpd(JSON.stringify(this.cForm)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("提交成功");
              this.$router.go(-1);
            }else {
              this.$message.error(response.msg);
            }      
          });
        
        }else {
          this.isFile = true
        }
      } 
    },
    handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm, name, [{
              name: response.name,
              url: response.url
            }])
            this.isFile = false
          }else{
            this.$set(this.cForm, name,[])
            this.isFile = true
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm, name, [])

      },
  }
}
</script>
<style scoped>
.tag{ font-size: 12px; color: #999; padding-left: 160px; margin-top: -10px; padding-bottom: 20px;}
.d-tag{margin:40px 20px 10px; color: #999999; font-size: 14px;}
.d-tag p{line-height: 30px;}
</style>
